import { CheckboxOption } from '../../Forms/Fields/CheckboxField';

interface WithPickOptions<T extends string = string> {
  options?: T[]
}

export type FolderOptionsType = 'remove_file_prefix';
export class FolderOptions {
  static asCheckboxOptions({ options }: WithPickOptions<FolderOptionsType> = {}) {
    const checkboxesOptions: CheckboxOption<FolderOptionsType>[] = [
      {
        id: 'remove_file_prefix',
        label: 'Al checkear este campo, se eliminarán los números iniciales del nombre de los archivos.',
      },
    ];
    if (options) {
      return checkboxesOptions.filter(({ id }) => options.includes(id));
    }

    return checkboxesOptions;
  }
}
